import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const filtros = {
	state: {
		filtros : {
			candidaturas : {
				estado : [],
				text : '',
				type : '',
			},
			ofertas : {},
			misofertas : {
				estado : [],
				date : 0,
				titulo :'',
				type : [],
				omitirLeidos : false,
				caducanPronto : false,
				soloConCandidatos : false
			}
		}
	},
	getters: {
		getfiltroscandidaturas : state => state.filtros.candidaturas,   
		getfiltrosofertas : state => state.filtros.ofertas,   
		getfiltrosmisofertas : state => state.filtros.misofertas,   
	}, 
	actions: {
		requestSetFiltroCandidatura : function({commit}, data){
			commit('setfiltrosCandidaturas',data);
		},
		requestSetFiltroOfertas : function({commit}, data){
			commit('setfiltrosOfertas',data);
		},
		requestSetFiltroMisOfertas : function({commit}, data){
			commit('setfiltrosMisOfertas',data);
		}
	},
	mutations: {
		setfiltrosCandidaturas : function(state,data){
			state.filtros.candidaturas = data;
		},
		setfiltrosOfertas : function(state, payload){
			Vue.set(state.filtros.ofertas, payload.type, payload.data);
		},
		setfiltrosMisOfertas : function(state,data){
			state.filtros.misofertas = data;
		}
	}
}

export default filtros;



// WEBPACK FOOTER //
// ./src/store/filtros.js